import { action, observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsShoppingPwaFlightInformationResults } from '__generated__/api';
import Analytics = FlightsShoppingPwaFlightInformationResults.Analytics;
import MultiItemDynamicCrossSellPrimer = FlightsShoppingPwaFlightInformationResults.MultiItemDynamicCrossSellPrimer;

export class FlightInformationStore extends Store {
  @observable public loading: boolean;
  @observable public checkoutLoading: boolean;
  @observable public analytics?: Analytics;
  @observable public multiItemDynamicCrossSellPrimer?: MultiItemDynamicCrossSellPrimer;
  @observable public baseOfferAncillaryID: string;
  @observable public priceChange: boolean;
  @observable public seatSelectionLoading: boolean;
  @observable public seatSelectionVisible: boolean;
  @observable public selectedSeatMapIndex = -1;
  public errorMessageTheme: string;
  public smartShoppingExperienceEligibility: boolean;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public enableCheckoutLoading = () => {
    this.checkoutLoading = true;
    // This is a hack for safari where on pressing back button the loading bar is still visible
    // and hence we are forcing a reload to be in parity with other browsers, where the reload always happen
    // https://jira.expedia.biz/browse/FFSUAT-273
    window.onpageshow = function (event) {
      /* istanbul ignore next */
      if (event.persisted) {
        window.location.reload();
      }
    };
  };

  @action
  public setSeatSelectionLoading = (seatSelectionLoading: boolean) => {
    this.seatSelectionLoading = seatSelectionLoading;
  };

  public cleanInitialSelectedSeatMapIndex = () => {
    this.selectedSeatMapIndex = -1;
  };
}

FlightInformationStore.DEFAULTS = {
  loading: true,
  checkoutLoading: false,
  priceChange: false,
  seatSelectionLoading: false,
  ancillaryIdCallNotNeeded: false,
  baseOfferAncillaryID: null,
  errorMessageTheme: null,
  selectedSeatMapIndex: -1
};
